export default __webpack_public_path__ + "static/media/hero-caro-mbl-new-3.db020089.png";